export default __webpack_public_path__ + "static/media/aditya.7ea626e8.jpg";